import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Modal,
  Switch,
} from '@a-ui/react';

import { fetchBlockCard, fetchUnblockCard } from 'actions/block';

const CardBlockSwitch = ({
    card,
    setShowAlert,
    setAlertContent,
    cardStatus,
    setCardStatus,
}) => {
  const dispatch = useDispatch();
  const [wantedCardStatus, setWantedCardStatus] = useState('init');
  const [showUnBlockedFailedModal, setShowUnBlockedFailedModal] = useState(false);
  const [showBlockedFailedModal, setShowBlockedFailedModal] = useState(false);

  const changeCardStatus = unlocked => {
    setWantedCardStatus(unlocked ? 'unblock' : 'block');
  }

  const unblockCard = () => {
    setWantedCardStatus('init');
    setAlertContent('We proberen je sorteerpas te deblokkeren, even geduld.')
    setShowAlert(true);
    dispatch(fetchUnblockCard(card.cardNumber)).then(({ payload, error }) => {
      setShowAlert(false);
      if (error) {
        setShowUnBlockedFailedModal(true);
      } else {
        setCardStatus(payload.isBlockedByUser ? 'blocked' : 'unlocked');
        setShowUnBlockedFailedModal(false);
      }
    });
  }

  const blockCard = () => {
    setWantedCardStatus('init');
    setAlertContent('We proberen je sorteerpas te blokkeren, even geduld.')
    setShowAlert(true);

    dispatch(fetchBlockCard(card.cardNumber)).then(({ payload, error }) => {
      setShowAlert(false);
      if (error) {
        setShowBlockedFailedModal(true);
      } else {
        setCardStatus(payload.isBlockedByUser ? 'blocked' : 'unlocked');
        setShowBlockedFailedModal(false);
      }
    });
  }

  const UnBlockCardModal = () => {
    return (
      <Modal
        appRootId="#root"
        ariaCloseLabel="Annuleren"
        title={{
          label: 'Sorteerpas deblokkeren'
        }}
        onClose={() => setWantedCardStatus('init')}
        shouldCloseOnOverlayClick={true}
        open={true}
        confirmButton={{
          id: "deblokkeren-modal-confirm",
          onClick: unblockCard,
          children: "Sorteerpas deblokkeren"
        }}
        cancelButton={{
          id: "deblokkeren-modal-cancel",
          emphasis: 'medium',
          onClick: () => setWantedCardStatus('init'),
          children: "Annuleren"
        }}
      >
        <p className="u-padding u-margin-bottom">
          Het kan even duren voor je sorteerpas weer beschikbaar is nadat je je sorteerpas geblokkeerd hebt.
        </p>
      </Modal>
    )
  }

  const UnBlockCardFailedModal = () => {
    return (
      <Modal
        appRootId="#root"
        ariaCloseLabel="Annuleren"
        title={{
          label: 'Sorteerpas deblokkeren mislukt'
        }}
        shouldCloseOnOverlayClick={true}
        open={true}
        confirmButton={{
          id: "deblokkeren-modal-confirm",
          onClick: unblockCard,
          theme: 'danger',
          children: "Opnieuw proberen"
        }}
        cancelButton={{
          id: "deblokkeren-modal-cancel",
          emphasis: 'medium',
          onClick: () => setWantedCardStatus('init'),
          children: "Annuleren"
        }}
      >
        <p className="u-padding u-margin-bottom">
          Het kan even duren voor je sorteerpas weer beschikbaar is nadat je je sorteerpas geblokkeerd hebt.
        </p>
      </Modal>
    )
  }

  const BlockCardModal = () => {
    return (
      <Modal
        appRootId="#root"
        ariaCloseLabel="Annuleren"
        title={{
          label: 'Sorteerpas blokkeren'
        }}
        onClose={() => setWantedCardStatus('init')}
        shouldCloseOnOverlayClick={true}
        open={true}
        confirmButton={{
          id: "blokkeren-modal-confirm",
          onClick: blockCard,
          children: "Sorteerpas blokkeren"
        }}
        cancelButton={{
          id: "blokkeren-modal-cancel",
          emphasis: 'medium',
          onClick: () => setWantedCardStatus('init'),
          children: "Annuleren"
        }}
      >
        <p className="u-padding u-margin-bottom">
          Als je je sorteerpas blokkeert, kan je deze niet meer gebruiken aan de sorteerstraatjes.
          Ook kan je je saldo niet opladen. Je kan je kaart online weer deblokkeren.
        </p>
        <p className="u-padding u-margin-bottom">
          Als je je A-kaart gebruikt als sorteerpas, blijven de andere functies van je A-kaart beschikbaar.
        </p>
      </Modal>
    )
  }

  const BlockCardFailedModal = () => {
    return (
      <Modal
        appRootId="#root"
        ariaCloseLabel="Annuleren"
        title={{
          label: 'Sorteerpas blokkeren mislukt'
        }}
        shouldCloseOnOverlayClick={true}
        open={true}
        confirmButton={{
          id: "blokkeren-modal-confirm",
          onClick: blockCard,
          theme: 'danger',
          children: "Opnieuw proberen"
        }}
        cancelButton={{
          id: "blokkeren-modal-cancel",
          onClick: () => setWantedCardStatus('init'),
          emphasis: 'medium',
          children: "Annuleren"
        }}
      >
        <p className="u-padding u-margin-bottom">
          Er is iets fout gegaan tijdens het blokkeren van je sorteerpas. Probeer later opnieuw.
        </p>
      </Modal>
    )
  }

  return (
    <>
      {wantedCardStatus === 'unblock' && <UnBlockCardModal />}
      {wantedCardStatus === 'block' && <BlockCardModal />}
      {showBlockedFailedModal && <BlockCardFailedModal />}
      {showUnBlockedFailedModal && <UnBlockCardFailedModal />}

      <Switch
        statusLabelSide="left"
        statusLabelOff="Geblokkeerd"
        statusLabelOn="Actief"
        id={"active-switch"}
        checked={cardStatus === 'unlocked'}
        onClick={() => changeCardStatus(cardStatus !== 'unlocked')} />
    </>
  );
};

export default CardBlockSwitch;